// One editorial marquee — "RESEARCH · STRATEGY · CONFIDENCE"
export default function Marquee({ text = "RESEARCH · STRATEGY · CONFIDENCE · PROPERTY INVESTMENT RESEARCH AND ADVISORY CENTRE ·", className = "" }) {
  const item = <span className="mx-8 inline-block">{text}</span>;
  return (
    <div className={`relative border-y border-[#1a2940] bg-[#060f1e] overflow-hidden py-6 ${className}`} data-testid="marquee">
      <div className="marquee-track font-serif text-3xl md:text-5xl text-[#cca24d]/85 tracking-widest uppercase whitespace-nowrap">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="flex-shrink-0">{item}</span>
        ))}
      </div>
    </div>
  );
}
